<template>
  <div class="app-about">
    <div class="app-about-logo">
      <div class="logo-cma-about"></div>
    </div>
    <h4 class="app-about-title">{{ $t("HELP_ABOUT.Cma_Title") }}</h4>
    <b-card-text class="app-about-text">
      {{ $t("HELP_ABOUT.Cma_Text") }}
    </b-card-text>
  </div>
</template>

<script>
import { BCardText } from 'bootstrap-vue'
export default {
    components: {
        BCardText
    }
};
</script>

<style lang="scss" scoped>
.app-about {
  padding: 8px 4px;
}

.app-about-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  .logo-cma-about {
    position: static !important;
    margin: 0 !important;
    left: auto !important;
  }
}

.app-about-title {
  text-align: center;
  font-weight: 600;
  margin-bottom: 16px;
}

.app-about-text {
  line-height: 1.7;
  text-align: justify;
  color: rgba(0, 0, 0, 0.65);
}
.dark-layout .app-about-text {
  color: rgba(255, 255, 255, 0.65);
}
</style>
